/**
 * Where a paged list puts its pager: at BOTH ends (13-ui-screens.md §4.6, client request
 * 8 Oct 2026 — "for paginations, now only at bottom, please add at the top as well").
 *
 * A list that only pages at the bottom makes somebody scroll past every row to reach the next
 * page, and a 50-row page under the larger text sizes (14-theme.md §5.4) is several screens
 * tall. The top copy is the SAME pager, not a summary of it: one `current`, one `onChange`, so
 * the two can never disagree, and whatever hides the bottom one (`hideOnSinglePage`, an empty
 * list) hides the top one too.
 *
 * Every paged antd `Table` spreads this into its `pagination`. The payroll and report screens
 * draw their own strip, `PaginationBar` in `reports/-components/report-ui.tsx`, and render it
 * twice with `edge="top"` on the upper copy.
 *
 * `placement`, not the deprecated `position`, and logical values: `topEnd`, not `topRight`
 * (antd 6 renamed both; the old ones still work but warn — see `SheetsTable`).
 */
import type { TablePaginationConfig } from 'antd';

export const PAGER_AT_BOTH_ENDS: NonNullable<TablePaginationConfig['placement']> = [
  'topEnd',
  'bottomEnd',
];
